<div class="main-table-container">
  <table class="content-table loading-header">
    <thead>
      <tr>
        <th>
          <div></div>
        </th>
        <th>
          <div></div>
        </th>
        <th>
          <div></div>
        </th>
        <th>
          <div></div>
        </th>
        <th>
          <div></div>
        </th>
      </tr>
    </thead>
  </table>
  <div class="spinner-container">
    <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
  </div>
</div>
